import React, { useEffect, useRef } from 'react';

const Particles: React.FC = () => {
  const particlesRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    if (!particlesRef.current) return;
    
    const container = particlesRef.current;
    const particleCount = 30;
    
    // Clear any existing particles
    container.innerHTML = '';
    
    // Create particles
    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement('div');
      particle.classList.add('particle');
      
      // Random size (3-8px)
      const size = Math.random() * 5 + 3;
      particle.style.width = `${size}px`;
      particle.style.height = `${size}px`;
      
      // Random position
      particle.style.left = `${Math.random() * 100}%`;
      particle.style.top = `${Math.random() * 100}%`;
      
      // Random animation delay
      particle.style.animationDelay = `${Math.random() * 20}s`;
      
      // Random color from theme variables
      const colors = [
        'var(--primary-color)', 
        'var(--secondary-color)', 
        'var(--accent-color)'
      ];
      particle.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      
      container.appendChild(particle);
    }
  }, []);
  
  return <div className="particles" ref={particlesRef} />;
};

export default Particles;